import {createActions} from 'client/framework';

export default createActions(null, [
  'TOGGLE_DIFFICULTY',
  'TOGGLE_INCLUDE_ANSWER_STATUS',
  'RESET_FILTERS',
  'SET_SORT_BY',
  'SET_IS_OPEN'
]);
